import { render, staticRenderFns } from "./message-cards.vue?vue&type=template&id=e56fa1de&scoped=true&"
import script from "./message-cards.vue?vue&type=script&lang=js&"
export * from "./message-cards.vue?vue&type=script&lang=js&"
import style0 from "./message-cards.vue?vue&type=style&index=0&id=e56fa1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56fa1de",
  null
  
)

export default component.exports